<template>
    <div class="default-article-list-container">
        <div class="list-top-big-adv">
            <div class="img-box">
                <el-image style="width: 100%; height: 100%;" :src="articleOne?articleOne.cover:''" fit="cover"></el-image>
                <div class="flag">
                    <p v-if="articleOne">{{articleOne.labels}}</p>
                </div>
            </div>
            <p @click="toArticleDetail(articleOne.id)">{{articleOne?articleOne.title:''}}</p>
        </div>
        <div class="list-tow-row-adv">
            <div class="adv-item-box">
                <div class="img-box">
                    <el-image style="width: 100%; height: 100%;" :src="articleTow?articleTow.cover:''" fit="cover"></el-image>
                </div>
                <p @click="toArticleDetail(articleTow.id)">{{articleTow?articleTow.title:''}}</p>
            </div>
            <div class="adv-item-box">
                <div class="img-box">
                    <el-image style="width: 100%; height: 100%;" :src="articleThree?articleThree.cover:''" fit="cover"></el-image>
                </div>
                <p @click="toArticleDetail(articleThree.id)">{{articleThree?articleThree.title:''}}</p>
            </div>
        </div>
        <ul>
            <li v-for="(item, i) in articleList" :key="i">
                <div class="img-box">
                    <img :src="item.cover?item.cover:''" alt="">
                </div>
                <div class="info-box">
                    <div class="flag-box">
                        <span class="flag">{{item.labels}}</span>
                        <span class="time">{{item.created_at}}</span>
                    </div>
                    <div class="title" @click="toArticleDetail(item.id)">{{item.title}}</div>
                    <div class="query-box">
                        <div class="dicsre">
                            <span class="source">{{item.source?item.source:item.author}}</span>
                            |
                            <div class="flag" v-if="item.parent_column">
                                <span>
                                    {{item.parent_column.name&&item.parent_column.name=='首页'?'湾潮':item.parent_column.name}}
                                </span>
                            </div>
                            <div class="flag" v-else>
                                <span v-if="item.get_column&&item.get_column.name">
                                    {{item.get_column.name=='首页'?'湾潮':item.get_column.name}}
                                </span>
                            </div>
                        </div>
                        <div class="icons">
                            <p class="icon-item">
                                <el-popover popper-class="yongjinpopper" placement="top" width="150" trigger="hover" 
                                    content="转发文章有机会得佣金" v-if="item.is_advertisement==1">
                                    <i class="icon iconfont icon-yongjin active" slot="reference"></i>
                                </el-popover>
                                <i class="icon iconfont icon-yongjin" v-else></i>
                            </p>
                            <p class="icon-item isclick">
                                <!-- <el-badge :max="99"></el-badge> -->
                                <i class="icon iconfont icon-dianzan" :class="{active:item.isLike}" @click="toLike(item)"></i>
                                <span>{{item.like_count}}</span>
                            </p>
                            <p class="icon-item isclick">
                                <i class="icon iconfont icon-pinglun3" @click="toArticleDetail(item.id, 1)"></i>
                                <span>{{item.comment_count}}</span>
                            </p>
                            <!-- <p class="icon-item">
                                <i class="icon iconfont icon-fenxiang" @click="toArticleDetail(item.id, false)"></i>
                                <span>{{item.forward_count}}</span>
                            </p> -->
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div class="get-more" @click="getMoreData()" v-show="articleList.length < total">点击加载更多</div>
        <div class="no-more" v-show="articleList.length >= total">没有更多了...</div>
        <!-- 二维码登录提示 -->
        <div class="qrcode-box" v-show="qrcodeShow">
            <i class="icon iconfont icon-shanchu2" @click="qrcodeShow = false"></i>
            <div id="wxLoginBox"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DefaultArticleList',
    data() {
        return {
            // 文章列表参数
            pageParams: {
                limit: 32,
                page: 1,
                total: 0
            },
            qrcodeShow: false
            // advArticles: {
            //     one: {}, tow: {}, three: {}
            // },
        }
    },
    computed: {
        // 当前所在栏目
        columnId() {
            return this.$store.state.pc.nowColumnParams.columnId;
        },
        // 栏目名称
        columnName() {
            return this.$store.state.pc.nowColumnParams.columnName;
        },
        articleOne() {
            
            return this.$store.state.pc.columnArticleData.articleOne;
        },
        articleTow() {
            return this.$store.state.pc.columnArticleData.articleTow;
        },
        articleThree() {
            return this.$store.state.pc.columnArticleData.articleThree;
        },
        articleList() {
            return this.$store.state.pc.columnArticleData.list;
        },
        total() {
            return this.$store.state.pc.columnArticleData.total;
        },
        // 是否登录
        isLogin() {
            return this.$store.state.isLogin;
        },
    },
    created() {
        let page = window.sessionStorage.getItem('_PAGE_'+this.columnId+'_');
        this.pageParams.page = page ? page : 1;
        // this.openBus();
        // setTimeout(() => {
        //     console.log('articleOne>>>', this.articleOne)
        // }, 5000);
    },
    methods: {
        openBus() {
            this.Bus.$on('getArticleData', res => {
                if(res) {
                    // this.Bus.$emit('destroyArticleCompnents', true);
                    this.pageParams = {
                        limit: 10,
                        page: 1,
                        total: 0
                    };
                    this.getArticleList(false);
                }
            });
        },
        /**
         * @function getShareData 获取分享参数
         */
        getShareData(item) {
            let href = 'https://www.bigbays.cn/articleDetailP?article_id=' + item.id + 
                '&from_user_id=0' + '&top_user_id=0' + '&article_key=' + '&parent_article_key=';
            mobShare.config( {
                debug: false, // 开启调试，将在浏览器的控制台输出调试信息
                appkey: '30209051a084c', // appkey
                params: {
                    url: href, // 分享链接
                    title: item.title, // 分享标题
                    description: item.summary, // 分享内容
                    pic: item.cover, // 分享图片，使用逗号,隔开
                    reason:'',//自定义评论内容，只应用与QQ,QZone与朋友网
                },
                /**
                 * 分享时触发的回调函数
                 * 分享是否成功，目前第三方平台并没有相关接口，因此无法知道分享结果
                 * 所以此函数只会提供分享时的相关信息
                 * @param {String} plat 平台名称
                 * @param {Object} params 实际分享的参数 { url: 链接, title: 标题, description: 内容, pic: 图片连接 }
                 */
                callback: function( plat, params ) {
                    // console.log('success>>>', plat, params);
                }
            });
        },
        /**
         * @function getArticleList 获取文章列表
         * @param { boolean } flag 是否拼接数据
         */
        getArticleList(flag) {
            this.$axios.get(this.Urls.articleList, {
                params: {
                    limit: this.pageParams.limit,
                    page: this.pageParams.page,
                    column_id: this.columnId
                }
            }).then(res => {
                // this.Bus.$emit('destroyArticleCompnents', false);
                let result = res.data.result, data = result.data;
                this.pageParams.total = result.total;
                if(data.length > 0) {
                    for(let i = 0; i < data.length; i++) {
                        if(data[i].cover) {
                            data[i].cover = this.cm.jointPicUrl(data[i].cover);
                        }
                        if(data[i].created_at) {
                            // data[i].updated_at = this.cm.transformTime(data[i].updated_at, false);
                            data[i].created_at = String(data[i].created_at).split(' ')[0];
                        }
                        if(data[i].labels) {
                            data[i].label = String(data[i].labels).split(',')[0];
                        }
                    }
                }
                this.articleList = flag ? this.articleList.concat(data) : data;
                this.articleOne = this.articleList[0];
                this.articleTow = this.articleList[1];
                this.articleThree = this.articleList[2];
            });
        },
        /**
         * @function toArticleDetail 去文章详情
         */
        toArticleDetail(...args) {
            let id = args[0];
            let path = this.columnId == 1 ? '/' : '/columnContentListP';
            let breadcrumbList = [
                { name: this.columnName, path: path, column_id: this.columnId }
            ];
            this.$store.commit('setBreadcrumbList', breadcrumbList);
            this.$router.push({ 
                path: '/articleDetailP', 
                query: { 
                    article_id: id,
                    article_key: '',
                    from_user_id: 0,
                    top_user_id: 0,
                    parent_article_key: '',
                    to_comment: args.length > 1 ? args[1] : 0
                } 
            });
        },
        /**
         * @function toLike 点赞
         */
        toLike(item) {
            if(this.isLogin) {
                item.isLike = !item.isLike;
                item.isLike ? item.like_count++ : item.like_count--;
                let type = item.isLike ? 'like' : 'unlike';
                let sendData = {
                    article_id: item.id,
                    operation: type
                };
                this.$axios.post(this.Urls.articleLike, sendData).then(res => {
                    // this.cm.notificationShow('温馨提示', res.data.message, 300);
                    if(res.data.status != 200) {
                        item.isLike ? item.like_count-- : item.like_count++;
                        item.isLike = !item.isLike;
                    }
                });
            } else {
                this.loginTips();
            }
        },
        /**
         * @function loginTips 登录提示
         */
        loginTips() {
            // this.cm.notificationShow('提示', '您还没有登录，请使用微信扫码登录！', 300);
            this.qrcodeShow = true;
            this.getWxLoginConfig();
        },
        /**
         * @function getWxLoginConfig 获取微信登录信息
         */
        getWxLoginConfig() {
            let flag = document.body.clientWidth > 500;
            if(flag) {
                this.$axios.get(this.Urls.wxLogin).then(res => {
                    let info = res.data.result;
                    const codeInfo = new WxLogin({
                        self_redirect: false,
                        id: "wxLoginBox", 
                        appid: info.app_id, 
                        scope: info.scope, 
                        redirect_uri: info.redirect_uri,
                        state: info.state,
                        style: "",
                        href: ""
                    });
                });
            }
        },
        /**
         * @function getMoreData 获取更多数据
         */
        getMoreData() {
            if(this.pageParams.page == 1) {
                this.pageParams.page = 5;
            } else {
                this.pageParams.page++;
            }
            let payload = {
                column_id: this.columnId,
                params:{
                    limit: 8, 
                    page: this.pageParams.page
                },
                flag: true
            };
            this.$store.dispatch('getArticleList', payload);
        }
    }
}
</script>
<style lang="scss" scoped>
@import './DefaultArticleList.scss';
</style>
<style lang="scss">
.yongjinpopper {
    text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pc/common/default-article-list/DefaultArticleList.vue